const analyticsNames = {
  age: 'Dogs age',
  role: 'Role parent',
  puppy_or_adult: 'Puppy or adult',
  how_old: 'How old',
  breed: 'Breed',
  dog_name: 'Dog name',
  goal: 'Dogs goal',
  biting: 'biting',
  potty_training: 'potty training',
  commands: 'commands',
  being_home_alone: 'being home alone',
  hygiene: 'hygiene',
  chewing: 'chewing',
  jumping_on_people: 'jumping on people',
  being_for_food: 'being for food',
  obedience: 'obedience',
  picking_up_from_the_ground: 'picking up from the ground',
  mail: 'Mail',
  
  customV1_gender: 'Gender',
  customV1_age: 'How old',
  customV1_breed: 'Breed',
  customV1_commands: 'Commands',
  customV1_descriptionV1: 'infoDrawUpPlan',
  customV1_nervous: 'Get nervous',
  customV1_anxious: 'Get anxious',
  customV1_stressed: 'Get stressed',
  customV1_being_home_alone: 'How often dog home alone',
  customV1_walk: 'How often walk',
  customV1_hygiene: 'Hygiene',
  customV1_concern: 'Main points of concern',
  customV1_dangerous_situation: 'Dangerous situation',
  customV1_these_commands: 'Your dog knows commands stay and stop',
  customV1_eat_something_bad: 'Your dog eat something bad',
  customV1_this_command: 'Your dog knows command leave it',
  customV1_afraid: 'Are you afraid your dog will get lost',
  customV1_descriptionV2: 'infoFeelingsNormal',
  customV1_when_called: 'Does your dog come when called',
  customV1_when_chews: 'Does it annoy you when your dog chews',
  customV1_boundaries: 'Do you know how to set boundaries',
  customV1_hard_training: 'Have you found dog training harder than you expected',
  customV1_main_goal: 'What is your main goal',
  customV1_training_time: 'How much time during the day can you spend training',
  customV1_loader: 'run_result_loader',
  customV1_email: 'Mail',
  customV1_startPage: 'welcome_screen',

  // customV2_startPage: 'page_load',
  customV2_policyPage: 'welcome_screen',
  customV2_policyPageV2: 'welcome_screen',
  customV2_policyPageV3: 'welcome_screen',
  customV2_policyPageV4: 'welcome_screen',
  customV2_policyPageV5: 'welcome_screen',
  customV2_gender: 'gender',
  customV2_name: 'name',
  customV2_age: 'age',
  customV2_breed: 'breed',
  customV2_health: 'health_issues',
  customV2_potty: 'potty',
  customV2_issues: 'issues_at_home',
  customV2_issues_2: 'issues',
  customV2_walking_issues: 'walking_issues',
  customV2_activity: 'activity',
  customV2_training_time: 'training_time',
  customV2_training: 'training_before',
  customV2_command_1: 'commands_1',
  customV2_command_2: 'commands_2',
  customV2_command_3: 'commands_3',
  customV2_command_4: 'commands_4',
  customV2_info_breed: 'info_about_breed',
  customV2_info_breed_2: 'info_about_problems',
  customV2_info_breed_3: 'problems_resolve',
  customV2_creating_program: 'perceive_dog',
  customV2_plan: 'plan',
  customV2_email: 'mail',
  customV2_videoPolicyPage: 'welcome_screen',
  customV2_start_page_video: 'start_page',
  customV2_reason: 'specific_reason',
  customV2_date: 'date',
  customV3_gender: 'gender',
  customV4_behavior_problem: 'behavior_problem',
  customV2_age_v2: 'age',
  customV2_age_v3: 'dog_type',
  customV2_age_v4: 'dog_type',
  customV2_age_v5: 'dog_type',
  customV5_behavior_problem: 'welcome_screen',
  customV2_info_predict: 'info_predict',
  customV2_food: 'food',
  issues_biting: 'biting',
  issues_damage: 'damage_furniture',
  issues_crate: 'crate',
  issues_home: 'alone_at_home',
  follow_commands: 'follow_commands',
  get_irritated: 'irritability',
  raise_voice: 'raise_your_voice',
  hit_dog: 'hit_your_dog',
  how_attached: 'how_attached',
  info_thank: 'sharing_thanks',
  customV2_potty_v2: 'potty',
  potty_how_long: 'potty_how_long',
  potty_where: 'potty_where',
  potty_how_often_walks: 'potty_how_often_walks',
  potty_health_issues: 'potty_health_issues',
  potty_where_want: 'potty_where_want',
  info_about_potty: 'info_about_potty',
  training_raise_voice: 'training_raise_voice',
  training_react_to_punishment: 'training_react_to_punishment',
  customV2_startPageV4: 'welcome_screen',
  customV2_startPageV11: 'welcome_screen',
  customV2_startPageV12: 'welcome_screen',
  customV2_startPageV13: 'welcome_screen',
  owner_feelings: 'owner_feelings',
  owner_sleep: 'owner_sleep',
  owner_puppy_behavior: 'owner_puppy_behavior',
  owner_puppy_managing: 'owner_puppy_managing',
  owner_puppy_affect: 'owner_puppy_affect',
  owner_support: 'owner_support',
  owner_concerns: 'owner_concerns',
  info_about_owner: 'info_about_owner',
  customV2_startPageV5: 'welcome_screen',
  statement_irritation: 'statement_irritation',
  statement_ignore_commands: 'statement_ignore_commands',
  statement_strong_bond: 'statement_strong_bond',
  customV2_startPageV6: 'welcome_screen',
  customV2_startPageV7: 'welcome_screen',
  customV2_startPageV8: 'welcome_screen',
  customV2_startPageGender: 'gender',
  customV2_quote: 'info_about_insights',
  main_goal: 'main_goal',
  receive_email: 'receive_email',
  gender_zw: 'gender',
  zw_age: 'age',
  customV2_specialOffer: 'discount',
  customV2_specialOffer_v2: 'special_offer',
  customV2_specialOffer_v3: 'special_offer',
  start_page_age: 'age',
  start_page_age_v3: 'age',
  customV2_startPageV17: 'welcome_screen',
  customV2_startPageV18: 'welcome_screen',
  customV2_startPageV19: 'welcome_screen',
  customV2_startPageV20: 'welcome_screen',
  customV2_startPageV21: 'welcome_screen',
  start_page_age_v2: 'age',
  customV2_startPageV22: 'welcome_screen',
  training_time: 'spend_training_time',
  customV2_startPageV23: 'welcome_screen',
  crate_trained: 'crate_trained',
  info_about_crate: 'info_about_crate',
  customV2_startPageV24: 'welcome_screen',
  accidents_how_often: 'accidents_how_often',
  accidents_what_do: 'accidents_what_do',
  concern_toilet_training: 'concern_toilet_training',
  info_about_potty_struggles: 'info_about_potty_struggles',
  puppy_issues_at_home: 'issues_at_home',
  puppy_chew: 'chew',
  puppy_bite_hands: 'bite_hands',
  puppy_leave_house: 'leave_house',
  fix_behavior_issues: 'fix_behavior_issues',
  info_about_training: 'info_about_training',
  puppy_commands: 'commands',
  first_puppy: 'first_puppy',
  customV2_startPageV25: 'welcome_screen',
  age_group: 'age_group',
  customV2_startPageV26: 'welcome_screen',
  customV2_startPageV27: 'welcome_screen',
  customV2_startPageV28: 'welcome_screen',
  customV2_startPageV30: 'welcome_screen',
  customV2_startPageV29: 'welcome_screen',
  customV2_startPageV31: 'welcome_screen',
  understanding: 'understanding',
  info_about_understanding: 'info_about_understanding',
  understanding_when: 'understanding_when',
  understanding_real_time: 'understanding_real_time',
  understanding_summary: 'understanding_summary',
};

export default analyticsNames;
